import React from 'react';
import Marquee from 'react-fast-marquee';
import { Shield, Award, Globe, FileCheck, Users, Zap, Scale, Star, Building2 } from 'lucide-react';

const items = [
  { text: 'TRUSTED BY 10,000+ BRANDS', icon: Users },
  { text: 'USPTO COMPLIANT', icon: FileCheck },
  { text: 'AMAZON REGISTRY READY', icon: Award },
  { text: 'LICENSED ATTORNEYS', icon: Shield },
  { text: 'FLAT-RATE PRICING', icon: Zap },
  { text: 'ALL 50 STATES', icon: Globe },
  { text: 'FEDERAL COURTS', icon: Scale },
  { text: '99% APPROVAL', icon: Star },
  { text: 'CORPORATE LAW', icon: Building2 },
];

const TrustBar = () => (
  <section data-testid="trust-bar" className="bg-[#093336]/50 py-4 overflow-hidden border-y border-white/5">
    <Marquee speed={25} gradient={false} pauseOnHover>
      {items.map((item, i) => {
        const Icon = item.icon;
        return (
          <span key={i} className="mx-8 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#A0B2B2]/60 flex items-center gap-2.5">
            <Icon className="w-3.5 h-3.5 text-[#A5BF23]/40" strokeWidth={1.5} />
            {item.text}
          </span>
        );
      })}
    </Marquee>
  </section>
);

export default TrustBar;
